import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../../appContext";
import PageStateMessage from "../../../shared/components/generic/page-state-message/page-state-message";
import { TokenUtils } from "../../../shared/utils/TokenUtils";
import { useDashboardClientContracts } from "../hooks/useDashboardClientContracts";
import DashboardContent from "./dashboard-content";

const Dashboard = () => {
	const { userSession } = useContext(AppContext);
	const [validation, setValidation] = useState(null);
	const { fetchClientContracts } = useDashboardClientContracts();

	useEffect(() => {
		let cancelled = false;

		const validateAccess = async () => {
			setValidation(null);

			if (!userSession) return;

			if (!TokenUtils.hasModuloDashboard()) {
				setValidation({ hasModuleAccess: false });
				return;
			}

			if (TokenUtils.isEssilor()) {
				setValidation({
					hasModuleAccess: true,
					clientContracts: null
				});
				return;
			}

			const result = await fetchClientContracts(TokenUtils.getUserCnpj());

			if (!cancelled) {
				setValidation({
					hasModuleAccess: true,
					...result
				});
			}
		};

		validateAccess();

		return () => {
			cancelled = true;
		};
	}, [userSession, fetchClientContracts]);

	if (!userSession || validation === null) {
		return <PageStateMessage title="Carregando..." />;
	}

	if (!validation.hasModuleAccess) {
		return (
			<PageStateMessage title="Acesso Negado">
				<p>Você não possui acesso ao módulo Dashboard.</p>
			</PageStateMessage>
		);
	}

	if (validation.ok === false) {
		return (
			<PageStateMessage title="Erro ao consultar contratos">
				<p>{validation.error}</p>
			</PageStateMessage>
		);
	}

	if (
		validation.clientContracts !== null &&
		validation.clientContracts.length === 0
	) {
		return (
			<PageStateMessage
				title="Você não tem contratos ativos no pacto rebates"
			/>
		);
	}

	return (
		<DashboardContent
			initialClientContracts={validation.clientContracts}
		/>
	);
};

export default Dashboard;